import React from 'react';
import ComponentHomolog from './ComponentHomolog';

export const ComponentHomologConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/homolog',
            component: ComponentHomolog
        }
    ]
};
